import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className='bg-gray-50 border-t border-gray-200 mt-16'>
      <div className='container mx-auto px-4 py-8'>
        <div className='grid md:grid-cols-3 gap-8'>
          <div>
            <h3 className='font-semibold text-gray-900 mb-4'>EdgeVector</h3>
            <p className='text-sm text-gray-600 leading-relaxed'>
              The world's most advanced edge-native database platform, combining MongoDB
              compatibility with AI-powered features and global edge distribution.
            </p>
          </div>

          <div>
            <h4 className='font-medium text-gray-900 mb-4'>Features</h4>
            <ul className='space-y-2 text-sm text-gray-600'>
              <li>• Vector Search & AI</li>
              <li>• Real-Time Streaming</li>
              <li>• Time Series Analytics</li>
              <li>• Global Edge Distribution</li>
              <li>• Multi-Paradigm Storage</li>
            </ul>
          </div>

          <div>
            <h4 className='font-medium text-gray-900 mb-4'>Resources</h4>
            <ul className='space-y-2 text-sm text-gray-600'>
              <li>
                <a href='#' className='hover:text-blue-600'>
                  Documentation
                </a>
              </li>
              <li>
                <a href='#' className='hover:text-blue-600'>
                  API Reference
                </a>
              </li>
              <li>
                <a href='#' className='hover:text-blue-600'>
                  Examples
                </a>
              </li>
              <li>
                <a href='#' className='hover:text-blue-600'>
                  Community
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className='mt-8 pt-4 border-t border-gray-200 text-center text-sm text-gray-500'>
          <p>&copy; 2025 EdgeVector. Built for the edge-native database revolution.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
